import { Card, Col, Row } from 'react-bootstrap';
import { teacherString } from '../../../../utils/string';
import { useLocation, useNavigate } from 'react-router-dom';
import Loader from '../../../../Global/loader';
const AssociatedSchools = (props: any) => {
  const navigate = useNavigate();
  const location = useLocation();
  // console.log(props.teacherDetails);
  if (!props.teacherDetails) {
    return (
      <Row className=" d-flex justify-content-center">
        <Col>
          <div className="w-50 m-auto text-center">
            <Loader />
          </div>
        </Col>
      </Row>
    );
  }
  return (
    <>
      <div className="card table-out">
        <div className="card-header bg-light border-2 pt-2">
          <h3 className="card-title card-label fs-22 fw-bolder fw-bold text-dark">
            {teacherString.associatedSchool}
          </h3>
        </div>
        <div className="card-body">
          <Row>
            {props.teacherDetails.associatedSchool.filter((schoolVal: any) => !schoolVal.school.isDeleted).map(
              (schoolVal: any, index: any) => (
                <Col
                  lg={6}
                  key={index}
                  className="pt-2 mb-5"
                >
                  <Card className="text-center bg-light">
                    <span className="text-gray-800 fw-bolder fs-18 ms-3">
                      {schoolVal.school.name}
                    </span>
                  </Card>
                  <Card>
                    <div className="d-flex align-items-center mb-8 customer">
                      <div className="flex-grow-1 ms-5 pt-5">
                        {schoolVal.class.map(
                          (classInfo: any, classIndex: number) => (
                            <div
                              key={classIndex}
                              className="mb-4"
                            >
                              <div className="text-gray-800 fw-bolder fs-18 mb-2">
                                {`${teacherString.class}: ${classInfo.name}`}
                              </div>
                              <div className="border-bottom mb-2"></div>
                              <div className="row">
                                {classInfo.division.map(
                                  (division: any, divisionIndex: number) => (
                                    <div
                                      key={divisionIndex}
                                      className="d-flex flex-row"
                                    >
                                      <div className="text-gray-800 fw-bold fs-6 mb-2 pe-5">
                                        {`${teacherString.division}: ${division.name} : `}
                                      </div>
                                      <div className="text-gray-800 fw-bold fs-6 ">
                                        {classInfo.subjects
                                          .filter(
                                            (subject: any) =>
                                              subject.divisionReference ===
                                              division.reference
                                          )
                                          .map((subject: any) => subject.name)
                                          .join(', ')}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </Card>
                </Col>
              )
            )}
          </Row>
        </div>
      </div>
    </>
  );
};
export default AssociatedSchools;
